import React from "react";
import {Link} from "react-router-dom";

const Projects = () => {
    return (
        <div>
            <h1>Projects</h1>
            <li>
                <Link to="/mumble-generator">Mumble Generator</Link>
            </li>

        </div>
    );
};

export default Projects;
